/**
 * ATP Scheduler — client: config only. Rularea task-urilor se face prin Cloud Function.
 * ZeroPath | ETF Layer 5
 */

import { db } from '../firebase';
import {
  doc,
  getDoc,
  setDoc,
  updateDoc,
  serverTimestamp
} from 'firebase/firestore';
import { getApp } from 'firebase/app';
import { getFunctions, httpsCallable } from 'firebase/functions';

const SCHEDULES_COLLECTION = 'atp_schedules';

const DEFAULT_FREQUENCY = { critical: 1, high: 3, medium: 7, low: 14 };
const DEFAULT_RANDOMIZATION_PERCENT = 20;

export async function getSchedulerConfig(organizationId) {
  try {
    const ref = doc(db, SCHEDULES_COLLECTION, organizationId);
    const snap = await getDoc(ref);
    if (!snap.exists()) return null;
    return { id: snap.id, ...snap.data() };
  } catch (err) {
    console.error('[atpSchedulerService] getSchedulerConfig:', err);
    throw err;
  }
}

export async function saveSchedulerConfig(organizationId, config, userId) {
  try {
    const ref = doc(db, SCHEDULES_COLLECTION, organizationId);
    const snap = await getDoc(ref);

    const data = {
      organization_id: organizationId,
      is_active: config.is_active ?? false,
      assigned_group_id: config.assigned_group_id || null,
      assigned_group_name: config.assigned_group_name || '',
      assigned_user_ids: config.assigned_user_ids || [],
      frequency: {
        critical: Number(config.frequency?.critical) || DEFAULT_FREQUENCY.critical,
        high: Number(config.frequency?.high) || DEFAULT_FREQUENCY.high,
        medium: Number(config.frequency?.medium) || DEFAULT_FREQUENCY.medium,
        low: Number(config.frequency?.low) || DEFAULT_FREQUENCY.low
      },
      randomization_window_percent: Number(config.randomization_window_percent) || DEFAULT_RANDOMIZATION_PERCENT,
      updated_at: serverTimestamp(),
      updated_by: userId
    };

    if (snap.exists()) {
      await updateDoc(ref, data);
    } else {
      await setDoc(ref, {
        ...data,
        last_run_at: null,
        next_run_at: null,
        created_at: serverTimestamp(),
        created_by: userId
      });
    }
  } catch (err) {
    console.error('[atpSchedulerService] saveSchedulerConfig:', err);
    throw err;
  }
}

/**
 * Apelează Cloud Function runATPSchedulerManual (us-central1).
 * @param {string} organizationId
 * @param {string} source - 'planned_ipc' | 'audit' | 'direct_observation' | 'incident' | 'capa'
 * @param {string|null} sourceId
 * @param {string|null} sourceRef
 */
export async function callManualRun(organizationId, source, sourceId = null, sourceRef = null) {
  const functions = getFunctions(getApp(), 'us-central1');
  const runManual = httpsCallable(functions, 'runATPSchedulerManual');
  const result = await runManual({
    organizationId,
    source,
    source_id: sourceId,
    source_ref: sourceRef
  });
  return result.data;
}

export const atpSchedulerService = {
  getSchedulerConfig,
  saveSchedulerConfig,
  callManualRun
};

export default atpSchedulerService;
